import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { Event } from "../models/Event";
import { Loading } from "./Loading";

interface EventGroup {
  date: string;
  events: Event[];
  current: boolean;
}

export const Weekly = ({ setSelectedView, client, getLocalDate }: any) => {
  const [eventGroups, setEventGroups] = useState<EventGroup[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dateFormat = "YYYY-MM-DD";

  useEffect(() => {
    const fetchEvents = async (date: string) => {
      let response = await client.get(`?date=${date}`);
      let sorted = (response.data as Event[]).sort((a, b) =>
        a.PostTimeLocal > b.PostTimeLocal ? 1 : -1
      );
      return { date: date, events: sorted, current: false };
    };

    const processCall = async () => {
      let groups: EventGroup[] = [];
      let day = moment();
      const numOfDays = 14;
      let i = 0;
      while (i < numOfDays) {
        i++;
        let temp = await fetchEvents(day.format(dateFormat));
        if (i == 0) {
          temp.current = true;
        }
        groups.push(temp);
        day = day.add(1, "days");
      }

      setEventGroups(groups);
      setIsLoading(false);
    };

    processCall();
  }, [client]);

  const sortedFilteredEventGroups = useMemo(() => {
    let sortableItems = [...eventGroups];

    return sortableItems.sort((a, b) => (a.date > b.date ? 1 : -1));
  }, [eventGroups]);

  const formatHeaderDate = (date: string) => {
    return moment(date).format("dddd[\r\n]MMM D YYYY");
  };

  let content = <Loading />;

  if (!isLoading) {
    content = (
      <div className="px-2">
        <div className="sm:flex sm:items-center">
          <div className="mt-1 flex">
            <button
              className="inline-flex items-center rounded-md border border-blue-300 bg-blue-50 px-3 text-blue-500 sm:text-sm py-2"
              onClick={() => setSelectedView("daily")}
            >
              Daily Schedule
            </button>
          </div>
        </div>
        <div className="mt-1 max-h-[600px] overflow-y-auto overflow-x-auto">
          <ul
            style={{ whiteSpace: "pre" }}
            className="grid grid-rows-1 grid-flow-col gap-1"
          >
            {sortedFilteredEventGroups.map((eventGroup) => (
              <li
                key={eventGroup.date}
                className="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white shadow"
              >
                <div className="border-b border-gray-900 bg-gray-600 px-4 py-2 sm:px-6">
                  <h3 className="text-sm font-semibold text-white">
                    {formatHeaderDate(eventGroup.date)}
                  </h3>
                </div>
                <div className="flex flex-1 flex-col px-4 py-2">
                  <ul>
                    {eventGroup.events.map((event) => (
                      <li
                        key={event.EventCode}
                        className="whitespace-nowrap text-xs text-gray-500"
                      >
                        {getLocalDate(event.RunDate, event.PostTimeLocal)}
                        {" - "}
                        {event.EventName}
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return <div>{content}</div>;
};
